import PropTypes from 'prop-types';
import {Icon} from 'front-onceforall-core';
import {INVITATION_TYPE} from '../../../utils/constant';

function UserInvitationView(props) {
  const {invitation} = props;

  return (
    <tr>
      <td>
        <span data-id="icon">
          <Icon icon={invitation.type === INVITATION_TYPE.INTERNAL ? 'check' : 'paper-plane'}/>
        </span>
      </td>
      <td>
        <strong data-id="fullName">{invitation.user.firstName}&nbsp;{invitation.user.lastName}</strong>
      </td>
      <td>
        <span data-id="email">{invitation.user.email}</span>
      </td>
      <td>
        <span
          className="clickable"
          data-id="trash"
          onClick={props.onDelete}
        >
          <Icon icon="trash"/>
        </span>
      </td>
    </tr>
  );
}

UserInvitationView.propTypes = {
  invitation: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default UserInvitationView;
